export const easterProducts = [
  {
    id: 'trio-ovos-50g',
    name: 'Trio de Ovos 50g',
    price: 12.00,
    priceFormatted: '€12,00',
    description: 'Um conjunto especial de três ovos de chocolate artesanais, cada um com a sua combinação única de sabores:',
    items: [
      'Casca de chocolate de leite, recheio de casadinho',
      'Casca de chocolate branco, recheio de lima com framboesa',
      'Casca de chocolate negro, recheio de coco e amêndoas com brigadeiro de leite',
    ],
    images: [
      '/images/trio1.jpeg',
      '/images/trio2.jpeg',
      '/images/trio3.jpeg',
    ],
  },
  {
    id: 'caixa-ovinhos-12',
    name: 'Caixa de Ovinhos 12 unidades',
    price: 17.40,
    priceFormatted: '€17,40',
    description: 'Uma caixa com 12 ovinhos de chocolate artesanais em quatro sabores irresistíveis:',
    items: [
      'Crocante de avelã',
      'Morango',
      'Casadinho',
      'Caramelo salgado',
    ],
    images: [
      '/images/ovo1.jpeg',
      '/images/ovo2.jpeg',
      '/images/ovo3.jpeg',
    ],
  },
  {
    id: 'ovos-recheados-20g',
    name: 'Ovos Recheados (20g)',
    price: 3.00,
    priceFormatted: '€3,00',
    description: 'Casca saborizada com cookies, recheio de cookies e creme.',
    items: [
      'Casca saborizada com cookies',
      'Recheio de cookies e creme',
    ],
    images: [
      '/images/rec1.jpeg',
      '/images/rec2.jpeg',
      '/images/rec3.jpeg',
    ],
  },
  {
    id: 'mini-coelhinhos-13g',
    name: 'Mini Coelhinhos (13g)',
    price: 1.50,
    priceFormatted: '€1,50',
    description: 'Chocolate de leite recheado com ganache de morango e chocolate.',
    items: [
      'Chocolate de leite',
      'Recheio de ganache de morango e chocolate',
    ],
    images: [
      '/images/coelho1.jpeg',
      '/images/coelho2.jpeg',
    ],
  },
  {
    id: 'brigadeiros-tematicos',
    name: 'Brigadeiros Tematicos',
    price: 8.75,
    priceFormatted: 'Desde €8,75',
    priceSuffix: '/ caixa',
    description: 'Sabores a escolha.',
    items: [
      'Caixa de 5 unidades - 2 sabores - €8,75',
      'Caixa de 6 unidades - 2 sabores - €10,50',
      'Caixa de 9 unidades - 3 sabores - €15,75',
      'Caixa de 12 unidades - 3 sabores - €21,00',
    ],
    priceOptions: [
      { label: 'Caixa de 5 unidades', flavors: '2 sabores', price: 8.75, priceFormatted: '€8,75' },
      { label: 'Caixa de 6 unidades', flavors: '2 sabores', price: 10.50, priceFormatted: '€10,50' },
      { label: 'Caixa de 9 unidades', flavors: '3 sabores', price: 15.75, priceFormatted: '€15,75' },
      { label: 'Caixa de 12 unidades', flavors: '3 sabores', price: 21.00, priceFormatted: '€21,00' },
    ],
    images: [
      '/images/brig1.jpeg',
      '/images/brig2.jpeg',
      '/images/brig3.jpeg',
      '/images/brig4.jpeg',
      '/images/brig5.jpeg',
      '/images/brig6.jpeg',
      '/images/brig7.jpeg',
    ],
  },
  {
    id: 'caixa-de-bombons-9',
    name: 'Caixa de Bombons',
    price: 13.50,
    priceFormatted: '€13,50',
    priceSuffix: '/ caixa',
    description: '9 unidades. Sabores variados a escolha.',
    items: [
      '9 unidades',
      'Sabores variados a escolha',
    ],
    images: [
      '/images/bom1.jpeg',
      '/images/bom2.jpeg',
      '/images/bom3.jpeg',
    ],
  },
  {
    id: 'ovos-recheados-50g',
    name: 'Ovos Recheados (50g)',
    price: 4.50,
    priceFormatted: '€4,50',
    description: 'Casca de chocolate de leite, recheado com doce de caju e batata chips.',
    items: [
      'Casca de chocolate de leite',
      'Recheado com doce de caju e batata chips',
    ],
    images: [
      '/images/cas1.jpeg',
      '/images/cas2.jpeg',
    ],
  },
  {
    id: 'ovos-de-colher-50g',
    name: 'Ovos de Colher (50g)',
    price: 4.50,
    priceFormatted: '€4,50',
    description: 'Sabores: Casadinho; Lima com framboesa; Coco com amendoas e brigadeiro de leite.',
    items: [
      'Casadinho',
      'Lima com framboesa',
      'Coco com amendoas e brigadeiro de leite',
    ],
    images: [
      '/images/pop1.jpeg',
      '/images/pop2.jpeg',
    ],
  },
];
